export default "__VITE_ASSET__33c12c93__"